// add artificial delay for very fast actions like downloading labels
// eslint-disable-next-line @typescript-eslint/promise-function-async
export const delayBy = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));
